import React from 'react';
import MainLayout from '../layouts/MainLayout';
import SEOHead from '../components/SEOHead';

const PrivacyPolicyPage = () => {
  return (
    <MainLayout skipNewsletter={true}>
      <SEOHead 
        title="Политика за поверителност - Refresh Bulgaria"
        description="Политика за поверителност на Refresh Bulgaria. Как събираме, използваме и защитаваме вашите лични данни в съответствие с GDPR."
        keywords="политика поверителност, защита данни, GDPR България, лични данни refresh bulgaria"
        url="https://refreshbulgaria.com/privacy-policy"
      />
      <div className="max-w-screen-xl mx-auto px-4">
        {/* Main content */}
        <main className="mt-8 mb-8">
          <div className="bg-white rounded-lg shadow-md p-6 md:p-8">
            <h1 className="text-3xl font-bold text-green-800 mb-6">Политика за поверителност</h1>
            
            <div className="space-y-6 text-gray-700">
              <section>
                <p className="text-lg leading-relaxed mb-6">Ценим Вашата поверителност и се ангажираме да защитаваме личните Ви данни. Тази политика обяснява как обработваме информацията, която споделяте с нас.</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-green-700 mb-3">Какви данни събираме</h2>
                <p className="mb-3">Събираме минимално количество информация, необходимо за нашите услуги:</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Имейл адрес</strong> - когато се абонирате за нашия бюлетин</li>
                  <li><strong>Анонимни данни за посещения</strong> - чрез Umami Analytics (без използване на бисквитки)</li>
                  <li><strong>Информация за дарения</strong> - обработвана директно от PayPal (ние не получаваме Вашите финансови данни)</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-green-700 mb-3">Как използваме данните</h2>
                <p>Вашият имейл адрес се използва единствено за изпращане на нашия бюлетин с новини за екологични инициативи и предстоящи събития. Никога няма да получавате спам или непоискани съобщения.</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-green-700 mb-3">Споделяне с трети страни</h2>
                <p className="mb-3">Работим с няколко доверени партньора за предоставяне на нашите услуги:</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Mailchimp</strong> - управлява изпращането на нашия бюлетин (<a href="https://mailchimp.com/legal/privacy/" target="_blank" rel="noopener noreferrer" className="text-green-600 hover:text-green-800 underline">политика за поверителност</a>)</li>
                  <li><strong>PayPal</strong> - обработва дарения (ние получаваме само информация за сумата и датата) (<a href="https://www.paypal.com/bg/webapps/mpp/ua/privacy-full" target="_blank" rel="noopener noreferrer" className="text-green-600 hover:text-green-800 underline">политика за поверителност</a>)</li>
                  <li><strong>Umami Analytics</strong> - анализира посещенията на уебсайта без съхраняване на лични данни (<a href="https://umami.is/privacy" target="_blank" rel="noopener noreferrer" className="text-green-600 hover:text-green-800 underline">политика за поверителност</a>)</li>
                </ul>
                <p className="mt-3">Никога не продаваме или споделяме Вашите данни с други организации за маркетингови цели. Споделяме информация само при законово изискване.</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-green-700 mb-3">Вашите права</h2>
                <p>Имате пълни права върху Вашите лични данни, включително право на достъп, корекция, изтриване и ограничаване на обработката. Можете да се отпишете от бюлетина по всяко време чрез линка в имейла или като се свържете с нас.</p>
                <p className="mt-2">За въпроси относно обработката на данни от PayPal при дарения, моля консултирайте се с тяхната политика за поверителност.</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-green-700 mb-3">Сигурност</h2>
                <p>Прилагаме подходящи технически и организационни мерки за защита на Вашите данни. Въпреки това, важно е да знаете, че нито една интернет система не може да гарантира 100% сигурност.</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-green-700 mb-3">Свържете се с нас</h2>
                <p>Ако имате въпроси относно тази политика или нашите практики за защита на данните, ще се радваме да чуем от Вас:</p>
                <p className="mt-2">Email: refrshbulgaria@gmail.com</p>
                <p>Телефон: +359 899 802 702</p>
              </section>

              <section className="border-t border-gray-200 pt-6 mt-8">
                <p className="text-sm text-gray-500 text-center">
                  Настоящата Политика е в сила от 30 юни 2025 г.
                </p>
              </section>
            </div>
          </div>
        </main>
      </div>
    </MainLayout>
  );
};

export default PrivacyPolicyPage;